import axios from './interceptor';

const QRY_URL = `${process.env.REACT_APP_BASE_URL}/hotel`;

export async function getAllHotels(params = {}) {
    const ADDUSER_URL = `${QRY_URL}/get-all`;
    const result = await axios.get(ADDUSER_URL, { params });
    return result.data;
};

export async function insertHotel(payload) {
    const ADDUSER_URL = `${QRY_URL}/create`;
    const result = await axios.post(ADDUSER_URL, payload);
    return result.data;
};

export async function updateHotel(id, payload) {
    const ADDUSER_URL = `${QRY_URL}/update/${id}`;
    const result = await axios.put(ADDUSER_URL, payload);
    return result.data;
};

export async function toggleHotelStatus(id, isActive) {
    const ADDUSER_URL = `${QRY_URL}/toggle-status/${id}`;
    const result = await axios.patch(ADDUSER_URL, { isActive });
    return result.data;
};

export async function deleteHotel(id) {
    const ADDUSER_URL = `${QRY_URL}/delete/${id}`;
    const result = await axios.delete(ADDUSER_URL);
    return result.data;
};

export async function extractHotelFromPdf(formData) {
    const EXTRACT_URL = `${QRY_URL}/extract-from-pdf`;
    const result = await axios.post(EXTRACT_URL, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
    return result.data;
};
